export default __webpack_public_path__ + "static/media/money.4e79c8ab.svg";